export enum ClientStatus {
  ACTIVE = 'Active',
  GRADUATED = 'Graduated',
  WITHDRAWN = 'Withdrawn',
  DISCHARGE = 'Discharge',
}
